import React from 'react';

import Button from '@material-ui/core/Button';

import { bareDateTimeFormat, t } from '../../providers';

const impersonateButton = (user) => {
    return (
        <Button
            aria-label="impersonate user"
            id={'impersonateButton'}
            onClick={() => {}}
            disableRipple
            disableFocusRipple
            style={{
                background: '#3F5E20',
                boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
                borderStadius: '2px',
                fontStyle: 'normal',
                fontWeight: '600',
                fontSize: '0.75rem',
                lineHeight: '133%',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                color: '#FFFFFF',
                minWidth: '110px',
                height: '24px',
            }}>
            {t('impersonate')}
        </Button>
    );
};

export const UserParserList = (users) => {
    const { content } = users;

    let applicationsViewList = {
        headers: [
            { label: t('user.id'), code: 'userId', align: 'left', sortable: false },
            { label: t('name'), code: 'name', align: 'left', sortable: false },
            { label: t('vat.id'), code: 'vatId', align: 'left', sortable: false },
            { label: t('citizen.id'), code: 'citizenId', align: 'left', sortable: false },
            { label: t('user.type'), code: 'userType', align: 'left', sortable: false },
            { label: t('current.status'), code: 'enabled', align: 'left', sortable: false },
            { label: t('parent.account'), code: 'parentAccount', align: 'left', sortable: false },
            { label: t('options'), code: 'options', align: 'left', sortable: false },
        ].filter((item) => typeof item === 'object'), //remove non-objects from headers
    };

    let dataList = [];

    // table/list data
    const parsedApp = (content || []).map((app, idx) => [
        {
            label: t('user.id'),
            value: app.username ? <span style={{ maxWidth: '200px' }}>{app.username}</span> : t('not.available'),
        },
        { label: t('name'), value: app.firstName && app.lastName ? `${app.firstName} ${app.lastName}` : t('not.available') },
        { label: t('vat.id'), value: app.attributes && app.attributes.NIF ? app.attributes.NIF.join(',') : t('not.available') },
        {
            label: t('citizen.id'),
            value: app.attributes && app.attributes.citizenID ? app.attributes.citizenID : t('not.available'),
        },
        {
            label: t('user.type'),
            value: app.attributes && app.attributes.profile ? app.attributes.profile.join(',') : t('not.available'),
        },
        { label: t('current.status'), value: app.enabled ? t('active') : t('inactive') },
        { label: t('parent.account'), value: app.attributes && app.attributes.parentUsername ? app.attributes.parentUsername : t('not.available') },
        {
            label: t('options'),
            value: impersonateButton(app.username),
        },
    ]);

    //remove non-objects from data
    dataList = parsedApp.map((app) => {
        return app.filter((item) => typeof item === 'object');
    });

    applicationsViewList = {
        ...applicationsViewList,
        data: dataList,
    };

    return applicationsViewList;
};

export const filtersParser = (filters) => {
    const startDateTime = 'T00:00:00';
    const endDateTime = 'T23:59:59';
    let parsedFilters = { ...filters };
    // remove mark word from trademark types
    if (parsedFilters.types && parsedFilters.types.length > 0) {
        const parsedTypes = parsedFilters.types.map((item) => item.replace(' mark', ''));
        parsedFilters = { ...parsedFilters, types: parsedTypes };
    }

    // Normalize date ranges to API accepted date range data type, if any.
    if (parsedFilters.dates) {
        parsedFilters = {
            ...parsedFilters,
            dates: parsedFilters.dates.reduce((allDates, { dateType, startDate, endDate }) => {
                if (!!dateType && !!startDate && !!endDate) {
                    allDates.push({
                        date: dateType,
                        dateFrom: `${bareDateTimeFormat(startDate, 'YY-mm-dd')}${startDateTime}`,
                        dateTo: `${bareDateTimeFormat(endDate, 'YY-mm-dd')}${endDateTime}`,
                    });
                }
                return allDates;
            }, []),
        };
    }

    return parsedFilters;
};
